export default __webpack_public_path__ + "static/media/down-arrow.f924ae2d.svg";